import { MapPin, Phone } from 'lucide-react';

const NAV = [
  { href: '#services', label: 'Servicios' },
  { href: '#kits', label: 'Kits' },
  { href: '#app', label: 'App' },
  { href: '#coverage', label: 'Cobertura' },
  { href: '#contact', label: 'Contacto' },
];

export function Footer() {
  return (
    <footer className="safe-bottom relative z-10 border-t border-white/[0.04] bg-[#030712] text-slate-400">
      <div className="container grid gap-10 py-14 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <a href="#top" className="flex items-center gap-2 font-bold text-white">
            <img src="/logo_visep_192.webp" alt="" className="h-9 w-9 object-contain" aria-hidden />
            <span className="text-lg">VISEP</span>
          </a>
          <p className="mt-3 max-w-xs text-sm text-slate-400">
            Seguridad integral para tu hogar, negocio y campo en todo el Paraguay.
          </p>
        </div>

        <nav aria-label="Pie de página">
          <h3 className="text-sm font-semibold text-white">Navegación</h3>
          <ul className="mt-3 space-y-2">
            {NAV.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="text-sm text-slate-400 transition-colors hover:text-white"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h3 className="text-sm font-semibold text-white">Contacto</h3>
          <ul className="mt-3 space-y-2 text-sm text-slate-400">
            <li className="flex items-center gap-2">
              <Phone className="h-4 w-4 text-primary" aria-hidden /> +595 21 123 456
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden />
              Av. Mcal. López esq. Gral. Santos, Asunción
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-white">Atención</h3>
          <p className="mt-3 text-sm text-slate-400">
            Operación 24/7, los 365 días del año.
          </p>
        </div>
      </div>
      <div className="border-t border-white/[0.04] py-6">
        <p className="container text-center text-xs text-slate-400">
          © {new Date().getFullYear()} VISEP. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
}
